export default "__VITE_ASSET__Du2m$Lve__"